import axios from 'axios';

class BasesDataService {
  getAll() {
    return axios.get(`/api/bases`);
  }

  getSimple() {
    return axios.get(`/api/bases/search`);
  }

  get(id) {
    return axios.get(`/api/bases/${id}`);
  }

  getEquivalencias(id) {
    return axios.get(`/api/bases/${id}/equivalencias`);
  }

  create(data) {
    return axios.post(`/api/bases`, data);
  }

  update(id, data) {
    return axios.put(`/api/bases/${id}`, data);
  }

  updateEquivalencias(id, data) {
    return axios.put(`/api/bases/${id}/equivalencias`, data);
  }

  updateUtilidades(id, data) {
    return axios.put(`/api/bases/${id}/utilidades`, data);
  }

  delete(id) {
    return axios.delete(`/api/bases/${id}`);
  }

  deleteAll() {
    return axios.delete(`/api/bases`);
  }
}

export default new BasesDataService();